/* eslint-disable react/no-unknown-property */
import { h, ComponentProps } from 'preact';
import classnames from 'classnames';

import { Svg } from './Svg';

type SvgProps = ComponentProps<typeof Svg> & {
    className?: string;
};

export const IconMenu = ({ className, ...rest }: SvgProps) => (
    <Svg className={classnames('c-icon c-icon--menu', className)} viewBox="0 0 24 24" {...rest}>
        <path d="M4.5 5.5H19.5" stroke-width="3" stroke-linecap="square" />
        <path d="M4.5 12.5H19.5" stroke-width="3" stroke-linecap="square" />
        <path d="M4.5 19.5H19.5" stroke-width="3" stroke-linecap="square" />
    </Svg>
);

export const IconClose = ({ className, ...rest }: SvgProps) => (
    <Svg className={classnames('c-icon c-icon--close', className)} viewBox="0 0 24 24" {...rest}>
        <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="M5 6l13.065 12.653M5 18.653L18.065 6"
        />
    </Svg>
);

export const IconCaretLeft = ({ className, ...rest }: SvgProps) => (
    <Svg
        className={classnames('c-icon c-icon--caret-left', className)}
        viewBox="0 0 36 36"
        {...rest}
    >
        <path
            fill="none"
            d="M20 27L11 18.5L20 10"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Svg>
);

export const IconCaretRight = ({ className, ...rest }: SvgProps) => (
    <Svg
        className={classnames('c-icon c-icon--caret-right', className)}
        viewBox="0 0 36 36"
        {...rest}
    >
        <path
            fill="none"
            d="M14 10L23 18.5L14 27"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </Svg>
);

export const IconCaretDown = ({ className, ...rest }: SvgProps) => (
    <Svg
        className={classnames('c-icon c-icon--caret-down', className)}
        viewBox="0 0 24 24"
        {...rest}
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.88 9.29006L12 13.1701L8.12 9.29006C7.73 8.90006 7.1 8.90006 6.71 9.29006C6.32 9.68006 6.32 10.3101 6.71 10.7001L11.3 15.2901C11.69 15.6801 12.32 15.6801 12.71 15.2901L17.3 10.7001C17.69 10.3101 17.69 9.68006 17.3 9.29006C16.91 8.91006 16.27 8.90006 15.88 9.29006Z"
        />
    </Svg>
);

export const IconArrowRight = ({ className, ...rest }: SvgProps) => (
    <Svg
        className={classnames('c-icon c-icon--arrow-right', className)}
        viewBox="0 0 18 15"
        {...rest}
    >
        <path d="M1.00031 6.5C0.44802 6.5 0.000305176 6.94772 0.000305176 7.5C0.000305176 8.05228 0.44802 8.5 1.00031 8.5V6.5ZM17.7074 8.20711C18.0979 7.81658 18.0979 7.18342 17.7074 6.79289L11.3435 0.428932C10.9529 0.0384078 10.3198 0.0384078 9.92924 0.428932C9.53871 0.819457 9.53871 1.45262 9.92924 1.84315L15.5861 7.5L9.92924 13.1569C9.53871 13.5474 9.53871 14.1805 9.92924 14.5711C10.3198 14.9616 10.9529 14.9616 11.3435 14.5711L17.7074 8.20711ZM1.00031 8.5H17.0003V6.5H1.00031V8.5Z" />
    </Svg>
);

export const IconPlay = ({ className, ...rest }: SvgProps) => (
    <Svg className={classnames('c-icon c-icon--play', className)} viewBox="0 0 24 25" {...rest}>
        <path
            fill-rule="evenodd"
            stroke-linejoin="round"
            stroke-width="2"
            d="M7 23.4V1l14 11.2L7 23.4Z"
            clip-rule="evenodd"
        />
    </Svg>
);

export const IconHelpBubble = (props: SvgProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 39 40" {...props}>
        <rect width="38" height="38" x=".5" y=".5" fill="#F9F9F9" rx="19" />
        <path
            fill="#F9F9F9"
            fill-rule="evenodd"
            stroke="#F9F9F9"
            stroke-linejoin="round"
            stroke-width="2"
            d="M26 35l8.218 4-1.298-9.521L26 35z"
            clip-rule="evenodd"
        />
        <path
            stroke="none"
            fill="#6E66DB"
            d="M17.56 22h3.84c0-1.656 3.84-2.76 3.84-6.336 0-3.12-2.736-4.8-5.472-4.8-2.664 0-4.992 1.392-6.048 3.864l3.312 1.896c.48-1.128 1.272-2.016 2.592-2.016 1.224 0 1.776.552 1.776 1.392 0 2.112-3.84 3.192-3.84 6zm1.92 6.336a2.295 2.295 0 002.28-2.28 2.295 2.295 0 00-2.28-2.28 2.295 2.295 0 00-2.28 2.28 2.295 2.295 0 002.28 2.28z"
        />
    </svg>
);

export const IconTickYes = ({ className, ...rest }: SvgProps) => (
    <Svg className={classnames('c-icon c-icon--yes', className)} viewBox="0 0 23 23" {...rest}>
        <path
            fill-rule="evenodd"
            d="M11.675.282c5.961 0 10.794 4.833 10.794 10.794S17.636 21.87 11.675 21.87.881 17.037.881 11.076 5.714.282 11.675.282Z"
            clip-rule="evenodd"
        />
        <path
            fill="none"
            stroke="#6E66DB"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="m6.614 10.728 3.844 4.007 5.935-6"
        />
    </Svg>
);

export const IconTickNo = ({ className, ...rest }: SvgProps) => (
    <Svg className={classnames('c-icon c-icon--no', className)} viewBox="0 0 22 23" {...rest}>
        <path
            fill-rule="evenodd"
            d="M10.881.488c5.961 0 10.794 4.833 10.794 10.794S16.842 22.076 10.88 22.076.087 17.243.087 11.282 4.92.488 10.881.488Z"
            clip-rule="evenodd"
        />
        <path
            fill="none"
            stroke="#434254"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="3"
            d="m7.331 14.838 7.035-7.112M14.367 14.838 7.33 7.726"
        />
    </Svg>
);
